
import { getScource } from "@/api/knowledge";
import { UserModule } from "@/store/modules/user";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "KnowledgeDetails",
  components: {},
})
export default class extends Vue {
  private detail: any = {};
  created() {
    this.getDetail();
  }
  private getDetail() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      id: this.$route.query.id,
    };
    getScource(params).then((res: any) => {
      this.detail = res.data;
    });
  }
  private detailsFiles(val: any) {
    window.open(val.full_path);
  }
}
